"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  font-size: 1.6rem;\n  line-height: 2rem;\n  font-family: ", ";\n  li {\n    color: ", ";\n    line-height: 2rem;\n    text-align: right;\n    margin-bottom: 1rem;\n    padding-right: 0.78vw;\n    cursor: pointer;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  padding-left: 0.78vw;\n  font-family: ", ";\n  overflow: ", ";\n  opacity: ", ";\n  max-height: ", ";\n  transition: opacity 0.5s, max-height 0.5s;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  padding-right: 0 !important;\n  margin-bottom: 0 !important;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  padding-right: 0.78vw;\n  border-right: 1px solid;\n  border-color: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-weight: 900;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Section = _styledComponents.default.li(_templateObject());

var SubSection = _styledComponents.default.li(_templateObject2(), function (_ref) {
  var active = _ref.active,
      theme = _ref.theme;
  return active ? theme.brand.primary : 'transparent';
});

var Item = _styledComponents.default.li(_templateObject3());

var SectionContainer = _styledComponents.default.ul(_templateObject4(), function (_ref2) {
  var theme = _ref2.theme;
  return theme.font;
}, function (_ref3) {
  var active = _ref3.active;
  return active ? 'auto' : 'hidden';
}, function (_ref4) {
  var active = _ref4.active;
  return active ? '1' : '0';
}, function (_ref5) {
  var active = _ref5.active;
  return active ? '100vh' : '0';
});

SubSection.propTypes = {
  active: _propTypes.default.bool
};

var StyledSubNavigation = _styledComponents.default.ul(_templateObject5(), function (_ref6) {
  var theme = _ref6.theme;
  return theme.font;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.typo.highlight;
});

var SubNavigation = function SubNavigation(_ref8) {
  var className = _ref8.className,
      children = _ref8.children,
      otherProps = _objectWithoutProperties(_ref8, ["className", "children"]);

  return _react.default.createElement(StyledSubNavigation, _extends({
    className: className
  }, otherProps), children);
};

SubNavigation.Section = Section;
SubNavigation.Section.displayName = 'SubNavigation.Section';
SubNavigation.SubSection = SubSection;
SubNavigation.SubSection.displayName = 'SubNavigation.SubSection';
SubNavigation.Item = Item;
SubNavigation.SectionContainer = SectionContainer;
SubNavigation.SectionContainer.displayName = 'SubNavigation.SectionContainer';
SubNavigation.propTypes = {
  className: _propTypes.default.string,
  otherProps: _propTypes.default.object,
  children: _propTypes.default.node
};
var _default = SubNavigation;
exports.default = _default;